import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // 共有モジュール
    SharedModule,
    // ルーティングモジュール
    RoutesRoutingModule,
  ]
})

export class RoutesModule { }
